import { APIFailureAction, APIRequestAction, APISuccessAction } from 'mk2/helpers/action';
import { NormalizedResponse } from 'mk2/helpers/api';

///////////////////////////////////////////////////////////////////
// Like info load

export const LIKE_INFO_FETCH_TRIGGER = 'LIKE_INFO_FETCH_TRIGGER';
export interface LikeInfoFetchTriggerAction {
    readonly type: typeof LIKE_INFO_FETCH_TRIGGER;
    readonly entityType: string;
    readonly entityId: number;
    readonly linkAccessKey: string;  // pouziva sa v blogoch na pristup k privatnym postom bez loginu
}
export const LIKE_INFO_FETCH_REQUEST = 'LIKE_INFO_FETCH_REQUEST';
export interface LikeInfoFetchRequestAction extends APIRequestAction {
    readonly type: typeof LIKE_INFO_FETCH_REQUEST;
    readonly entityType: string;
    readonly entityId: number;
}
export interface LikeInfoFetchNormalizedResponse extends NormalizedResponse {
    readonly result: { likers: number[]; };
}
export const LIKE_INFO_FETCH_SUCCESS = 'LIKE_INFO_FETCH_SUCCESS';
export interface LikeInfoFetchSuccessAction extends APISuccessAction<LikeInfoFetchNormalizedResponse> {
    readonly type: typeof LIKE_INFO_FETCH_SUCCESS;
    readonly entityType: string;
    readonly entityId: number;
}
export const LIKE_INFO_FETCH_FAILURE = 'LIKE_INFO_FETCH_FAILURE';
export interface LikeInfoFetchFailureAction extends APIFailureAction {
    readonly type: typeof LIKE_INFO_FETCH_FAILURE;
    readonly entityType: string;
    readonly entityId: number;
}

export const likeInfoFetchTrigger = (entityType: string, entityId: number, linkAccessKey?: string): LikeInfoFetchTriggerAction => ({
    type: LIKE_INFO_FETCH_TRIGGER, entityType, entityId, linkAccessKey,
});
export const likeInfoFetchApi = {
    request: (entityType: string, entityId: number): LikeInfoFetchRequestAction => ({
        type: LIKE_INFO_FETCH_REQUEST, entityType, entityId,
    }),
    success: (entityType: string, entityId: number, response: LikeInfoFetchNormalizedResponse): LikeInfoFetchSuccessAction => ({
        type: LIKE_INFO_FETCH_SUCCESS, entityType, entityId, response,
    }),
    failure: (entityType: string, entityId: number, error: any): LikeInfoFetchFailureAction => ({
        type: LIKE_INFO_FETCH_FAILURE, entityType, entityId, error,
    }),
};
